import Vue from 'vue'
import Vuex from 'vuex'
import navigation from './navigation'
import auth from './auth'
import tenantConfig from './tenant-config'
import landingPage from './landing-page'
import productCatalog from './product-catalog'
import sabaAd from './saba-ad'
import subscription from './subscription'
import tenantDesign from './tenant-design'
import contactUs from './contact-us'
import cdn from './cdn'
import modalManager from './modal-manager'
import order from './order'
import registration from './registration'
import userDemographic from './userDemographic'
import userReview from './user-review'
import meta from './meta'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    navigation,
    auth,
    meta,
    tenantConfig,
    tenantDesign,
    landingPage,
    productCatalog,
    sabaAd,
    subscription,
    contactUs,
    cdn,
    modalManager,
    order,
    registration,
    userDemographic,
    userReview
  }
})
